import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosError } from "axios";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import * as XLSX from "xlsx";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import PdfTotalPage from "../../actions/pdf_part/PdfTotal/PdfTotalExport";
import SkeletonLoaderWithText from "../../components/Loading/SkeletonLoaderWithText";
import MDButton from "../../components/MDButton";
import { Modal, Pagination } from "@mui/material";
import { FaEdit, FaTrash } from "react-icons/fa";
import { deleteCargo } from "../../actions/cargo/cargo";

export default function ReportTotalListPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJens, setSelectedJens] = useState([]);

  const [totals, setTotals] = useState({
    total_weight: 0,
    total_operations: 0,
    total_duration: 0,
    total_fare: 0,
    total_cost: 0,
    total_count: 0,
  });
  const [meta, setMeta] = useState({});

  const handleOpenModal = (jensList) => {
    setSelectedJens(jensList);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedJens([]);
  };
  const [reportData, setReportData] = useState([]);
  const [paging, setPaginate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedItems, setSelectedItems] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingExportPdf, setLoadingExportPdf] = useState(false);
  const handleCheckboxChange = (item) => {
    if (selectedItems.includes(item)) {
      setSelectedItems(selectedItems.filter(i => i.id !== item.id));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };
  const location = useLocation();
  const payload = localStorage.getItem("reportPayload");

  useEffect(() => {

    if (payload) {
      const params = new URLSearchParams(searchParams);
      const page = params.get("page") || 1;

      const fetchData = async () => {
        try {
          const token = Cookies.get("login_token");

          setLoading(true);
          const parsedPayload = JSON.parse(payload);

          params.forEach((value, key) => {
            parsedPayload[key] = value;
          });

          const response = await axios.post(`${process.env.REACT_APP_API_URL}/ReportWeb/Reports/all?page=${page}`, parsedPayload,
            {
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });

          setReportData(response.data.data);
          if (response.data.meta) {
            setMeta(response.data.meta);
            if (response.data.meta.totals) {
              setTotals(response.data.meta.totals);
            }
          }
          setLoading(false);
        } catch (error) {
          if (axios.isAxiosError(error)) {
            const axiosError = error;
            if (axiosError.response && axiosError.response.status === 401) {
              toast.error("نشست منقضی شده !");

              navigate("/authentication/sign-in");
            }
            return {
              status: "error",
              message: axiosError.message || "خطا در اتصال به سرور",
            };
          }
          toast.error("خطا در دریافت اطلاعات!");
        }
      };
      fetchData();
    }
  }, [searchParams]);
  const fetchAllReport = async () => {
    if (payload) {
      try {
        setLoadingExport(true);
        const token = Cookies.get("login_token");

        const parsedPayload = JSON.parse(payload);
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/ReportWeb/Reports/all`, parsedPayload,
          {
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
        setLoadingExport(false);

        const data = response.data.data.map((item) => ({
          "تاریخ و ساعت": item.date || "",
          "شماره حواله": item.cargo_code || "",
          "پیمانکار": item.peymankar?.name || "",
          "پروژه": item.project?.title || "",
          "محل استقرار": item.location?.name || "",
          "دستگاه": item.machine?.name || "",
          "نوع دستگاه": item.machine?.type || "",
          "شیفت": item.shift?.name || "",
          "نقص فنی": item.defect?.name || "",
          "تاخیر": item.delays?.name || "",
          "تراز": item.balance || "",

          "راننده": item.driver?.name || "",
          "مدت زمان عملیات": item.duration || "",
          "کرایه": item.amount_with || "",
          "هزینه کل عملیات": item.sum_amount_with || "",
          "کالا": (item.jens || [])
            .map(
              (subItem, index) =>
                `کالا: ${subItem["defination"]?.["title"] || "نامشخص"}، کد کالا: ${
                  subItem["jens_code"]?.["title"] || "نامشخص"
                }، تعداد: ${subItem["jens_unit"] || "نامشخص"}، شماره کالا: ${
                  subItem["jens_number"] || "نامشخص"
                }، واحد: ${subItem["weight"]?.["title"] || "نامشخص"}، وزن: ${
                  subItem["weight_unit"] || "نامشخص"
                }`,
            )
            .join("\n"),
          "مبدا": item.origin?.title || "",
          "مقصد": item.destination?.title || "",
          "تجهیز بارگیری": item.equipment?.name || "",
          "اپراتور": item.operator?.name || "",
          "نام مسئول عملیات": item.user?.name || "",
        }));
        const summery_data = [
          {
            "مجموع وزن": totalWeight,
            "تعداد عملیات": totalOperations,
            "مجموع زمان‌ها": totalDuration + " ساعت",
            "مجموع کرایه": totalFare + " ریال",
            "مجموع کل هزینه‌ها": totalCost + " ریال",
            "تعداد": totalCountJens,
          },
        ];
        const fullData = [...summery_data, ...data];

        const worksheet = XLSX.utils.json_to_sheet(fullData, { header: Object.keys(fullData[0]) });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Bargo");
        XLSX.writeFile(workbook, "گزارشات-بارگو.xlsx");
      } catch (error) {
        setLoadingExport(false);

        if (axios.isAxiosError(error)) {
          const axiosError = error;
          if (axiosError.response && axiosError.response.status === 401) {
            toast.error("نشست منقضی شده !");

            navigate("/authentication/sign-in");
          }
          return {
            status: "error",
            message: axiosError.message || "خطا در اتصال به سرور",
          };
        }
        toast.error("خطا در دریافت اطلاعات!");
      }
    }
  };
  const exportToExcel = async () => {
    if (selectedItems.length === 0) {
      await fetchAllReport();
      return;
    }
    const data = selectedItems.map((item) => ({
      "تاریخ و ساعت": item.date || "",
      "شماره حواله": item.cargo_code || "",
      "پیمانکار": item.peymankar?.name || "",
      "پروژه": item.project?.title || "",
      "محل استقرار": item.location?.name || "",
      "دستگاه": item.machine?.name || "",
      "نوع دستگاه": item.machine?.type || "",
      "شیفت": item.shift?.name || "",
      "نقص فنی": item.defect?.name || "",
      "تاخیر": item.delays?.name || "",
      "تراز": item.balance || "",
      "راننده": item.driver?.name || "",
      "مدت زمان عملیات": item.duration || "",
      "کرایه": item.amount_with || "",
      "هزینه کل عملیات": item.sum_amount_with || "",
      "کالا": (item.jens || [])
        .map(
          (subItem, index) =>
            `کالا: ${subItem["defination"]?.["title"] || "نامشخص"}، کد کالا: ${
              subItem["jens_code"]?.["title"] || "نامشخص"
            }، تعداد: ${subItem["jens_unit"] || "نامشخص"}، شماره کالا: ${
              subItem["jens_number"] || "نامشخص"
            }، واحد: ${subItem["weight"]?.["title"] || "نامشخص"}، وزن: ${
              subItem["weight_unit"] || "نامشخص"
            }`,
        )
        .join("\n"),
      "مبدا": item.origin?.title || "",
      "مقصد": item.destination?.title || "",
      "تجهیز بارگیری": item.equipment?.name || "",
      "اپراتور": item.operator?.name || "",
      "نام مسئول عملیات": item.user?.name || "",
    }));
    const summery_data = [
      {
        "مجموع وزن": totalWeight,
        "تعداد عملیات": totalOperations,
        "مجموع زمان‌ها": totalDuration + " ساعت",
        "مجموع کرایه": totalFare + " ریال",
        "مجموع کل هزینه‌ها": totalCost + " ریال",
        "تعداد": totalCountJens,
      },
    ];
    const fullData = [...summery_data, ...data];

    const worksheet = XLSX.utils.json_to_sheet(fullData, { header: Object.keys(fullData[0]) });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bargo");
    XLSX.writeFile(workbook, "گزارشات-بارگو.xlsx");
  };
  const generatePDF = async () => {
    const parsedPayload = JSON.stringify(payload);
    const token = Cookies.get("login_token");

    try {
      setLoadingExportPdf(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/ReportWeb/Reports/all`,
        parsedPayload,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,

          },
        },
      );

      const datas = response.data.data.map((item) => ({
        id: item.id || 0,
        position: item.position || "",
        date: item.date || "",
        cargo_code: item.cargo_code || "",
        peymankar: { name: item.peymankar?.name || "" },
        project: { title: item.project?.title || "" },
        location: { name: item.location?.name || "" },
        machine: { name: item.machine?.name || "", type: item.machine?.type || "" },
        driver: { name: item.driver?.name || "" },
        shift: { name: item.shift?.name || "" },
        defect: { name: item.defect?.name || "" },
        delays: { name: item.delays?.name || "" },
        balance: item.balance || "",
        duration: item.duration || "",
        amount_with: item.amount_with || "",
        sum_amount_with: item.sum_amount_with || "",
        jens: item.jens || [],
        origin: { title: item.origin?.title || "" },
        destination: { title: item.destination?.title || "" },
        equipment: { name: item.equipment?.name || "" },
        operator: { name: item.operator?.name || "" },
        user: { name: item.user?.name || "" },
      }));
      const blob = await pdf(<PdfTotalPage data={datas} />).toBlob();

      // دانلود فایل PDF
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "bargo-report.pdf"; // نام فایل PDF
      link.click();
      setLoadingExportPdf(false);

      return response.data; // داده‌های بازگشتی
    } catch (error) {
      setLoadingExportPdf(false);
      throw error;
    }
  };
  const navigate = useNavigate();

  const handleNavigateToMap = (lat, long) => {
    navigate("/reports/lists/map", { state: { lat, long } });
  };
  const handleNavigateToImages = (id) => {
    navigate("/reports/lists/images", { state: { id } });
  };

  const totalWeight = totals.total_weight;
  const totalCountJens = totals.total_count;
  const totalOperations = totals.total_operations;
  const totalDuration = totals.total_duration;
  const totalFare = totals.total_fare;
  const totalCost = totals.total_cost;

  const formatNumber = (number) => {
    if (typeof number === "number") {
      return number.toLocaleString("fa-IR");
    }
    return number;
  };
  return (
    <div>
      <DashboardLayout>
        <div className={"grid gap-3 grid-cols-2 md:grid-cols-6"}>
          <div
            className="w-full mx-2 border-2 py-4 border-graydark sm:w-auto bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-4 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700">
            <div className="text-left rtl:text-right">
              <div className="mb-1 text-xs text-graydark dark:text-white">مجموع وزن</div>
              <div className={"text-graydark text-sm dark:text-white"}>{totalWeight} </div>
            </div>
          </div>
          <div
            className="w-full mx-2 border-2 border-graydark sm:w-auto bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-4 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700">
            <div className="text-left rtl:text-right">
              <div className="mb-1 text-xs text-graydark dark:text-white">تعداد</div>
              <div className={"text-graydark text-sm dark:text-white"}>{totalCountJens} </div>
            </div>
          </div>
          <div
            className="mx-2 w-full border-2 border-graydark sm:w-auto bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-4 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700">
            <div className="text-left rtl:text-right">
              <div className="mb-1 text-xs text-graydark dark:text-white">تعداد عملیات</div>
              <div className={"text-graydark text-sm dark:text-white"}>{totalOperations}</div>
            </div>
          </div>
          <div
            className="mx-2 w-full border-2 border-graydark sm:w-auto bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-4 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700">
            <div className="text-left rtl:text-right">
              <div className="mb-1 text-xs text-graydark dark:text-white">مجموع زمان‌ها</div>
              <div className={"text-graydark text-sm dark:text-white"}>{totalDuration} ساعت</div>
            </div>
          </div>
          <div
            className="mx-2 w-full border-2 border-graydark sm:w-auto bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-4 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700"
          >
            <div className="text-left rtl:text-right">
              <div className="mb-1 text-xs text-graydark dark:text-white">مجموع کرایه</div>
              <div className="text-graydark text-sm dark:text-white">{formatNumber(totalFare)} ریال</div>
            </div>
          </div>
          <div
            className="mx-2 w-full border-2 border-graydark sm:w-auto bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-4 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700"
          >
            <div className="text-left rtl:text-right">
              <div className="mb-1 text-xs text-graydark dark:text-white">مجموع کل هزینه‌ها</div>
              <div className="text-graydark text-sm dark:text-white">{formatNumber(totalCost)} ریال</div>
            </div>
          </div>

        </div>

        <div className={"flex w-full items-center gap-4  mt-10"}>

          {selectedItems.length > 0 ?
            <PDFDownloadLink
              className="flex items-center px-5 py-2.5 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              document={<PdfTotalPage data={selectedItems} />}
              fileName="bargo-report.pdf"
            >
              خروجی پی دی اف
              <img src="/images/pdf.svg" alt="" className="w-5 h-5 ms-4" />

            </PDFDownloadLink>
            : <MDButton
              color={"info"}
              onClick={() => {
                generatePDF();
              }}
              type="button"
              disabled={loadingExportPdf}
              className="flex items-center px-5 py-2.5 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              {loadingExportPdf ? "درحال دریافت گزارش..." : "خروجی پی دی اف"}
              <img src="/images/pdf.svg" alt="" className="w-5 h-5 ms-4" />
            </MDButton>
          }
          <MDButton
            color={"success"}
            onClick={() => {
              exportToExcel();
            }}
            type="button"
            disabled={loadingExport}
            className="flex items-center px-5 py-2.5 text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          >
            {loadingExport ? "درحال دریافت گزارش..." : "خروجی اکسل"}
            <img src="/images/excel.svg" alt="" className="w-5 h-5 ms-4" />
          </MDButton>
        </div>

        {
          loading ? <SkeletonLoaderWithText /> :
            <>
              <div className="mt-5 relative overflow-x-auto shadow-md sm:rounded-lg">

              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead
                  className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th className="px-6 py-3">انتخاب</th>
                  <th scope="col" className="px-6 py-3">
                    تاریخ و ساعت
                  </th>
                  <th scope="col" className="px-6 py-3">
                    شماره حواله
                  </th>
                  <th scope="col" className="px-10 text-center py-3">
                    پیمانکار
                  </th>
                  <th scope="col" className="px-6 py-3">
                    پروژه
                  </th>
                  <th scope="col" className="px-16 text-center justify-center w-full py-3"
                      style={{ whiteSpace: "nowrap" }}>
                    محل استقرار
                  </th>
                  <th scope="col" className="px-10 py-3">
                    دستگاه
                  </th>
                  <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                    نوع دستگاه
                  </th>
                  <th scope="col" className="px-16 py-3">
                    شیفت
                  </th>
                  <th scope="col" className="px-16 py-3">
                    نقص فنی
                  </th>
                  <th scope="col" className="px-16 py-3">
                    تاخیر
                  </th>

                  <th scope="col" className="px-16 py-3">
                    تراز
                  </th>
                  <th scope="col" className="px-16 py-3">
                    راننده
                  </th>
                  <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                    مدت زمان عملیات
                  </th>
                  <th scope="col" className="px-16 py-3">
                    کرایه
                  </th>
                  <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                    هزینه کل عملیات
                  </th>
                  <th scope="col" className="px-16 py-3">
                    کالا
                  </th>
                  <th scope="col" className="px-16 py-3">
                    مبدا
                  </th>
                  <th scope="col" className="px-16 py-3">
                    مقصد
                  </th>
                  <th scope="col" className="px-16 py-3">
                    تجهیز بارگیری
                  </th>
                  <th scope="col" className="px-16 py-3">
                    اپراتور
                  </th>
                  <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                    نام مسئول عملیات
                  </th>
                  <th scope="col" className="px-16 py-3">
                    عملیات
                  </th>
                  <th scope="col" className="px-16 py-3">
                    توضیحات
                  </th>
                  <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                    نوع گزارش
                  </th>
                  <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                    وضعیت
                  </th>
                  <th scope="col" className="px-16 py-3">
                    تصاویر
                  </th>
                  <th scope="col" className="px-10 py-3">
                    موقعیت
                  </th>
                  <th scope="col" className="px-20 py-3" style={{ whiteSpace: "nowrap" }}>
                    عملیات
                  </th>
                </tr>
                </thead>
                <tbody>
                {reportData.map((item, index) => (
                  <tr
                    className="border-b bg-white hover:bg-gray-50 dark:bg-boxdark dark:border-gray-700 dark:hover:bg-gray-600"
                    key={index}
                  >
                    <td className="px-6 py-4">
                      <input
                        type="checkbox"
                        checked={selectedItems.includes(item)}
                        onChange={() => handleCheckboxChange(item)}
                      />
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white" dir="ltr"
                        style={{ whiteSpace: "nowrap" }}>
                      {item["date"] ? item["date"] :
                        <span className={"font-normal"}>ثبت نشده</span>
                      }
                    </td>
                    {/*<td className="px-6 py-4 font-semibold text-gray-900 dark:text-white" dir="ltr"*/}
                    {/*    style={{ whiteSpace: "nowrap" }}>*/}
                    {/*    {item["date"] ? item["date"] + " " + item["created_at"].split(" ")[0] :*/}
                    {/*      <span className={"font-normal"}>ثبت نشده</span>*/}
                    {/*    }*/}
                    {/*</td>*/}
                    <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
                      {item["cargo_code"] ? item["cargo_code"] :
                        <span className={"font-normal"}>ثبت نشده</span>
                      }
                    </td>
                    <td className="text-center w-full py-4">
                      <div className="text-center flex justify-center items-center ">
                        {item["peymankar"] && item["peymankar"]["name"] ? (
                          <span className={"font-bold"}>{item["peymankar"]["name"]}</span>
                        ) : (
                          <span className={"font-normal"}>ثبت نشده</span>
                        )}
                      </div>
                    </td>
                    <td
                      className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["project"] && item["project"]["title"] ? (
                        item["project"]["title"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="py-4 text-center justify-center font-semibold text-gray-900 dark:text-white">
                      {item["location"] && item["location"]["name"] ? (
                        item["location"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["machine"] && item["machine"]["name"] ? (
                        item["machine"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["machine"] && item["machine"]["type"] ? (
                        item["machine"]["type"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                        style={{ whiteSpace: "nowrap" }}>
                      {item["shift"] && item["shift"]["name"] ? (
                        item["shift"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                        style={{ whiteSpace: "nowrap" }}>
                      {item["delays"] && item["delays"]["name"] ? (
                        item["delays"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                        style={{ whiteSpace: "nowrap" }}>
                      {item["defect"] && item["defect"]["name"] ? (
                        item["defect"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td className="px-16 text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                        style={{ whiteSpace: "nowrap" }}>
                      {item["balance"] ? item["balance"] :
                        <span className={"font-normal"}>ثبت نشده</span>
                      }
                    </td>
                    <td
                      className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["driver"] && item["driver"]["name"] ? (
                        item["driver"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="px-16 text-center justify-center py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["duration"] ? item["duration"] :
                        <span className={"font-normal"}>ثبت نشده</span>
                      }
                    </td>
                    <td
                      className="text-center justify-center px-10 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["amount_with"] ? `${item["amount_with"]} تومان` :
                        <span className={"font-normal"}>ثبت نشده</span>
                      }
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["sum_amount_with"] ? `${item["sum_amount_with"]} تومان` :
                        <span className={"font-normal"}>ثبت نشده</span>
                      }
                    </td>
                    <td className="px-5 py-4 font-semibold flex-col text-gray-900 dark:text-white">
                      <button
                        onClick={() => handleOpenModal(item["jens"])}
                        className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        نمایش کالا
                      </button>
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["origin"] && item["origin"]["title"] ? (
                        item["origin"]["title"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["destination"] && item["destination"]["title"] ? (
                        item["destination"]["title"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["equipment"] && item["equipment"]["name"] ? (
                        item["equipment"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["operator"] && item["operator"]["name"] ? (
                        item["operator"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["user"] && item["user"]["name"] ? (
                        item["user"]["name"]
                      ) : (
                        <span className={"font-normal"}>ثبت نشده</span>
                      )}
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["type"] ? item["type"] :
                        <span className={"font-normal"}>ثبت نشده</span>
                      }
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["desc"] ? item["desc"] :
                        <span className={"font-normal"}>ثبت نشده</span>
                      }
                    </td>
                    <td
                      className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                      {item["isWeightBridge"] === 1 ?
                        <span className={"text-blue-600"}>باسکول</span> :
                        <span className={"text-blue-600"}>بارگو</span>}
                    </td>
                    <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white"
                        style={{ whiteSpace: "nowrap" }}>
                      {item["kartabl_status"] === 1 ? <span className={"text-blue-600"}>درانتظار تایید</span> :
                        <span className={"text-green-600"}>تایید شده</span>}
                    </td>
                    <td className="p-4">
                      <MDButton
                        disabled={item["isWeightBridge"] === 1}
                        color={"info"}
                        onClick={() => handleNavigateToImages(item["id"])}
                        style={{ whiteSpace: "nowrap" }}
                        className="custom-link text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        نمایش تصاویر
                      </MDButton>
                    </td>
                    <td className="px-6 py-4">
                      <MDButton
                        disabled={item["isWeightBridge"] === 1}
                        color={"info"}
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => handleNavigateToMap(item["position"]?.["latitude"], item["position"]?.["longitude"])}
                        className="custom-link text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        موقعیت بر روی نقشه
                      </MDButton>
                    </td>
                    <td className="flex p-4 gap-4">
                      <MDButton
                        color={"info"}
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => navigate(`/cargos/edit/${item.id}`)
                        }
                        className="custom-link text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center gap-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        <FaEdit className="text-base" />
                        ویرایش
                      </MDButton>
                      <MDButton
                        color={"error"}
                        style={{ whiteSpace: "nowrap" }}
                        onClick={async () => {
                          if (!window.confirm("آیا میخواهید این گزارش حذف شود؟")) {
                            return;
                          }
                          const response = await deleteCargo({ id: item["id"] }).then((res) => {
                            toast.success("با موفقیت حذف شد!");
                            window.location.reload();
                          }).catch((e) => {
                            toast.error("خطا در حذف گزارش!");
                          });
                        }}
                        className="custom-link text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center gap-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                      >
                        <FaTrash className="text-base" />
                        حذف
                      </MDButton>
                    </td>

                  </tr>
                ))}

                </tbody>
              </table>

            </div>
            {meta.last_page > 1 && (
              <div className="flex justify-center mt-4 pb-4" dir="ltr">
                <Pagination
                  count={meta.last_page}
                  page={meta.current_page || 1}
                  onChange={(event, value) => {
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set("page", value);
                    setSearchParams(newParams);
                  }}
                  color="primary"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            )}
            </>}
      </DashboardLayout>
      <Modal
        open={isModalOpen}
        className="mt-10 absolute inset-0 flex justify-center items-center z-10"
        onClick={handleCloseModal}
      >
        <div
          className="bg-white no-scrollbar overflow-y-auto h-1/2 dark:bg-boxdark p-6 rounded-lg max-w-3xl w-full shadow-lg"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center mb-6 border-b border-gray pb-4">
            <h2 className="text-xl font-bold text-gray-700 dark:text-white">لیست کالا</h2>
            <button
              onClick={handleCloseModal}
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="mb-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {selectedJens.map((subItem, index) => (
              <div
                key={index}
                className="bg-gray-50 dark:bg-gray-800 rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow duration-300"
              >
                <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                  کالا: {subItem["jens"]["title"]}
                </div>
                <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                  کد کالا: {subItem["jens_code"]["title"]}
                </div>
                <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                  تعداد: {subItem["jens_unit"]}
                </div>
                <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                  شماره کالا: {subItem["jens_number"]}
                </div>
                <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                  واحد: {subItem["weight"]["title"]}
                </div>
                <div className="text-gray-700 text-lg dark:text-gray-200">
                  وزن: {subItem["weight_unit"]}
                </div>
              </div>
            ))}
          </div>
          <MDButton
            color={"error"}
            onClick={handleCloseModal}
            className="mt-6 text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
          >
            بستن
          </MDButton>
        </div>
      </Modal>
    </div>
  );
}
